// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-row_manage_slots_settings {
    margin-top: 2rem;
  }
  
  .slot-row_manage_slots_settings h4 {
    font-size: 1rem;
    font-weight: 600;
    color: #4a4a4a;
    margin-bottom: 0.5rem;
    display: inline-block;
  }
  
  .slot-message_manage_slots_settings {
    font-style: italic;
    color: #777;
  }
  
  .station-slot-grid_manage_slots_settings {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 1rem;
    background-color: #f9f9f9;
  }
  
  /* Station Tabs */
  .station-tabs_manage_slots_settings {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    flex-wrap: wrap;
  }
  
  .station-tab_manage_slots_settings {
    padding: 0.4rem 0.8rem;
    background-color: #e0e7ff;
    border: none;
    border-radius: 6px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    color: var(--clr-primary-6);
  }
  
  .station-tab_manage_slots_settings.active {
    background-color: var(--clr-primary-5);
    color: white;
  }
  
  .station-tab_manage_slots_settings:hover {
    background-color:var(--clr-primary-3);
    color: white;
  }
  
  /* Slot List */
  .slot-list_manage_slots_settings {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.6rem;
    padding: 0;
  }
  
  .slot-item_manage_slots_settings {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    text-align: center;
    border-radius: 6px;
    background-color: var(--clr-grey-8);
    cursor: pointer;
    font-size: 0.8rem;
    transition: all 0.2s ease;
    border: 1px solid transparent;
    padding: 0 0.5rem; 
    white-space: nowrap;
  }
  
  
  .slot-item_manage_slots_settings:hover {
    background-color: #dbeafe;
    border-color: #60a5fa;
  }
  
  .slot-item_manage_slots_settings.selected {
    background-color: var(--clr-primary-4);
    color: white;
    font-weight: 550;
  }
  
  /* Action Buttons */
  .slot-actions_manage_slots_settings {
    margin-top: 1.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
  
  .mark-unavailable-btn_manage_slots_settings,
  .clear-btn_manage_slots_settings {
    padding: 0.6rem 1.2rem;
    border-radius: 6px;
    font-size: 0.9rem;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .mark-unavailable-btn_manage_slots_settings {
    background-color: #ef4444;
    color: white;
  }
  
  .mark-unavailable-btn_manage_slots_settings:disabled {
    background-color: #fca5a5;
    cursor: not-allowed;
  }
  
  .clear-btn_manage_slots_settings {
    background-color: var(--clr-grey-8);
    color: #111827;
  }
  
  .clear-btn_manage_slots_settings:hover {
    background-color: var(--clr-grey-7);
  }
  
  /* Responsive */
  @media (max-width: 600px) {
    .slot-list_manage_slots_settings {
      grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
    }
  
    .station-tab_manage_slots_settings {
      font-size: 0.8rem;
      padding: 0.3rem 0.6rem;
    }
  
    .mark-unavailable-btn_manage_slots_settings,
    .clear-btn_manage_slots_settings {
      width: 100%;
      text-align: center;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Configurations/tabs/ManageSlots/manageSlotsParts/styles/SlotGrid.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA,cAAc;EACd;IACE,gBAAgB;IAChB,aAAa;IACb,4DAA4D;IAC5D,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;EACrB;;;EAGA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;EAClB;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,mCAAmC;EACrC;;EAEA,eAAe;EACf;IACE;MACE,2DAA2D;IAC7D;;IAEA;MACE,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;;MAEE,WAAW;MACX,kBAAkB;IACpB;EACF","sourcesContent":[".slot-row_manage_slots_settings {\n    margin-top: 2rem;\n  }\n  \n  .slot-row_manage_slots_settings h4 {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #4a4a4a;\n    margin-bottom: 0.5rem;\n    display: inline-block;\n  }\n  \n  .slot-message_manage_slots_settings {\n    font-style: italic;\n    color: #777;\n  }\n  \n  .station-slot-grid_manage_slots_settings {\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 1rem;\n    background-color: #f9f9f9;\n  }\n  \n  /* Station Tabs */\n  .station-tabs_manage_slots_settings {\n    display: flex;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    flex-wrap: wrap;\n  }\n  \n  .station-tab_manage_slots_settings {\n    padding: 0.4rem 0.8rem;\n    background-color: #e0e7ff;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    color: var(--clr-primary-6);\n  }\n  \n  .station-tab_manage_slots_settings.active {\n    background-color: var(--clr-primary-5);\n    color: white;\n  }\n  \n  .station-tab_manage_slots_settings:hover {\n    background-color:var(--clr-primary-3);\n    color: white;\n  }\n  \n  /* Slot List */\n  .slot-list_manage_slots_settings {\n    list-style: none;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n    gap: 0.6rem;\n    padding: 0;\n  }\n  \n  .slot-item_manage_slots_settings {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 42px;\n    text-align: center;\n    border-radius: 6px;\n    background-color: var(--clr-grey-8);\n    cursor: pointer;\n    font-size: 0.8rem;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n    padding: 0 0.5rem; \n    white-space: nowrap;\n  }\n  \n  \n  .slot-item_manage_slots_settings:hover {\n    background-color: #dbeafe;\n    border-color: #60a5fa;\n  }\n  \n  .slot-item_manage_slots_settings.selected {\n    background-color: var(--clr-primary-4);\n    color: white;\n    font-weight: 550;\n  }\n  \n  /* Action Buttons */\n  .slot-actions_manage_slots_settings {\n    margin-top: 1.5rem;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n  \n  .mark-unavailable-btn_manage_slots_settings,\n  .clear-btn_manage_slots_settings {\n    padding: 0.6rem 1.2rem;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n  }\n  \n  .mark-unavailable-btn_manage_slots_settings {\n    background-color: #ef4444;\n    color: white;\n  }\n  \n  .mark-unavailable-btn_manage_slots_settings:disabled {\n    background-color: #fca5a5;\n    cursor: not-allowed;\n  }\n  \n  .clear-btn_manage_slots_settings {\n    background-color: var(--clr-grey-8);\n    color: #111827;\n  }\n  \n  .clear-btn_manage_slots_settings:hover {\n    background-color: var(--clr-grey-7);\n  }\n  \n  /* Responsive */\n  @media (max-width: 600px) {\n    .slot-list_manage_slots_settings {\n      grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n    }\n  \n    .station-tab_manage_slots_settings {\n      font-size: 0.8rem;\n      padding: 0.3rem 0.6rem;\n    }\n  \n    .mark-unavailable-btn_manage_slots_settings,\n    .clear-btn_manage_slots_settings {\n      width: 100%;\n      text-align: center;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
